import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { CrudStoreItemScout } from 'legacy/lut/classes/models/CrudStoreItemScout'
import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { IMainParam } from 'legacy/lut/classes/models/onboarding/IMainParam'
import { INotificationData } from 'legacy/lut/classes/models/onboarding/INotificationTemplate'
import { IRequestDataExt } from 'legacy/lut/classes/models/onboarding/IRetailRequestData'
import { IReconfirmationDetails } from 'legacy/lut/components/widgets/public/onboarding/bpReconfirmation/detailedList/models/IReconfirmationDetails'
import { IBPRegistrationCompanyData } from 'legacy/lut/components/widgets/public/onboarding/bpRegistration/models'
import {
  parseJson,
  parseObject,
} from 'legacy/lut/components/widgets/public/onboarding/helpers/parsers'
import { IExtendAction } from 'legacy/lut/components/widgets/public/onboarding/myActions/MyActions'
import { ICollectorData } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/dataCollector/ICollectorData'
import { getResponsibleUsers } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/primaryUsers/helpers/getResponsibleUsers'
import { getRequest } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestDetail/actionView/useRequestData'
import { TActionForm } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestForms/types'
import { convertToServerPaginationIfNot } from 'legacy/lut/functions'
import { history } from 'legacy/lut/helpers/route'
import { appGetState } from 'legacy/lut/store'

import { IForm } from 'core-components/classes/models/IForm'
import { deleteParamsFromUrl, getUrlParam } from 'core-components/helpers/url'
import { NotificationController } from 'core-components/library/popup'
import { IPaging, IPagingFromTo } from 'core-components/types'
import {
  IDataProviderFilter,
  IDataProviderSort,
  IFilter,
  Logic,
  Operator,
} from 'core-components/types'
import {
  setEndDate,
  setStartDate,
  toServerDateTimeOffset,
  toServerFormat,
} from 'core/classes/helpers/DateHelper'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import { IFormCollector } from 'core/classes/models/IFormCollector'
import { ICountry } from 'core/classes/models/IReference'
import { CrudStoreItemCore } from 'core/classes/services/InitializationServiceCore'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'
import { isInstanceOf } from 'core/utils/functions'
import Logger from 'core/utils/Logger'
import { legacyRidApi, TLegacyRidRead } from 'onboarding/api/legacyRidApi'
import { thirdPartyLogsApi, ThirdPartyTypeCrudCacheKeys } from 'onboarding/api/thirdPartyLogsApi'
import { PartnerHelper } from 'onboarding/classes/helpers/PartnerHelper'
import { CodeType } from 'onboarding/classes/models/partnerFlag'
import { onboardingUploadHistoryApi } from 'onboarding/classes/services/api/OnboardingUploadHistoryApi'
import { fail } from 'onboarding/classes/services/notification'

import { IBackupUser } from '../models/IBackupUser'
import { IFormSearchCodes } from '../models/IFormSearchCodes'
import { IActionTransition } from '../models/onboarding/ActionTransition'
import { IAction } from '../models/onboarding/IAction'
import { INotificationAttachment } from '../models/onboarding/INotificationAttachment'
import { IRequest } from '../models/onboarding/IRequest'
import { EActionStatus, RequestStatus, RequestTypes } from '../models/onboarding/Onboarding'

import OnboardingApi, { TExecuteTransitionPayload, TRequestTriad } from './api/OnboardingApi'

const getServiceSortVariant = (sort: IDataProviderSort | IDataProviderSort[] | undefined) => {
  if (!sort) {
    return undefined
  }
  if (Array.isArray(sort)) {
    return sort
  }
  return [sort]
}

export const showMessage = (message: string) => {
  NotificationController.showError({ message })
}
const unvisibleStatuses = [EActionStatus.New, EActionStatus.Waiting, EActionStatus.NADone]

export interface IWorkFlowStepState {
  EntryId: number
  RequestId: number
  Step: string
  ActionId: number
  Name: string
  Status: EActionStatus
  TransitionId: number
  MainParameter: string // it's no BPRedMainParams. For HP_ATTEND it's BP_RBI_new
}

export class OnboardingStoreService {
  public parseAudienceSettings = (
    audienceConditionAsString: string,
    countries?: ICountry[],
    responsiblePrimaryUser?: string,
    responsibleBackupUser?: string,
    currentUser?: string,
    onlyRespUserIsApprover?: boolean
  ) => {
    if (
      responsiblePrimaryUser &&
      currentUser &&
      responsiblePrimaryUser.toLowerCase() === currentUser.toLowerCase()
    ) {
      return { Email: [currentUser] }
    }
    if (
      responsibleBackupUser &&
      currentUser &&
      responsibleBackupUser.toLowerCase() === currentUser.toLowerCase()
    ) {
      return { Email: [currentUser] }
    }
    if (!audienceConditionAsString || onlyRespUserIsApprover) {
      return { UserRoles: [], HpOrg: [], Country: [], Email: [] }
    }
    const splitted = audienceConditionAsString.split(/AND|OR/)
    const parsed = splitted.map((el) => el.replace(/[()]/g, '').trim())
    const formed = parsed.map((el) => {
      const operator = el.match(/\s[^\s]+\s/)
      const splittedByOperator = operator && el.split(operator[0])
      return splittedByOperator && operator
        ? {
            field: splittedByOperator[0],
            operator: operator[0].trim(),
            value: splittedByOperator[1]
              ? splittedByOperator[1]
                  .replace(/'/g, '')
                  .split(',')
                  .map((i) => i.trim())
              : [],
          }
        : {}
    })
    const emailAudience = formed.find((el) => el.field === 'Email')
    if (emailAudience) {
      return { Email: emailAudience.value }
    }
    const result = formed.reduce((acc: IObjectAny, cur: any) => {
      if (cur.operator === '=' || cur.operator === 'LIKE' || cur.operator === 'IN') {
        if (acc[cur.field]) {
          acc[cur.field] = [...acc[cur.field], ...cur.value]
          return acc
        }
        return { ...acc, [cur.field]: cur.value }
      }
      return acc
    }, {} as IObjectAny)

    if (result.Country && result.Country.length && countries) {
      const countriesCode = result.Country.map((country: string) => {
        const found = countries.find((obj) => obj.name === country)
        if (found) {
          return found.value
        }
        return country
      })
      return { ...result, Country: countriesCode }
    }
    return result
  }

  public getProcessesProgressByRequestId = async (requestId: number) => {
    const source = CrudStore.get(CrudStoreItemOnboarding.ProcessesProgress, 'processesProgress')
    source.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'RequestId',
          operator: Operator.EQUAL,
          value: requestId,
        },
      ],
    })
    const result = await source.fetch({ force: true, skipTotal: true })
    return result.items
  }

  public getTransitionsByRequest = async (requestId: string): Promise<IActionTransition[]> => {
    const source = CrudStore.get(CrudStoreItemOnboarding.ActionTransitions, 'actionTransitions')
    source.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'RequestId',
          operator: Operator.EQUAL,
          value: requestId,
        },
      ],
    })
    const result = await source.fetch()
    return result.items as IActionTransition[]
  }

  public getTransitionsByFilter = async (
    filter: IDataProviderFilter
  ): Promise<IActionTransition[]> => {
    const source = CrudStore.get(CrudStoreItemOnboarding.ActionTransitions, 'actionTransitions')
    source.setFilter(filter)
    const result = await source.fetch()
    return result.items as IActionTransition[]
  }

  public getTransitionsByActUUID = async (
    actionUUID: string,
    requestId: string
  ): Promise<IActionTransition[]> => {
    const source = CrudStore.get(CrudStoreItemOnboarding.ActionTransitions, 'actionTransitions')
    source.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'RequestId',
          operator: Operator.EQUAL,
          value: requestId,
        },
        {
          field: 'ActionUUID',
          operator: Operator.EQUAL,
          value: actionUUID,
        },
      ],
    })
    const result = await source.fetch()
    return result.items as IActionTransition[]
  }

  public getCollectedDataByRequest = async (requestId: number): Promise<ICollectorData[]> => {
    const source = CrudStore.get(CrudStoreItemOnboarding.CollectedData)
    source.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'RequestId',
          operator: Operator.EQUAL,
          value: requestId,
        },
      ],
    })
    const result = await source.fetch({ force: true, skipTotal: true })
    return result.items as ICollectorData[]
  }

  public getContract = async (id: string) => {
    const source = CrudStore.get(CrudStoreItemOnboarding.ContractsList, 'Contract Data')
    return await source.getById(id)
  }

  public getSpecialization = async (parentSpec: string) => {
    const source = CrudStore.get(CrudStoreItemOnboarding.Specializations)
    return await source.getById({ id: parentSpec, keyField: 'SpzCode' })
  }

  public getPartnerAgreements = async (partnerId: string) => {
    let agreements: IFormSearchCodes[] = []
    const partnerFlagsSource = CrudStore.get(
      CrudStoreItemScout.WW_PartnerFlags,
      'partner-agreements'
    )
    partnerFlagsSource.setFilter({
      logic: Logic.AND,
      filters: [
        { field: 'PARTNER_ID', operator: Operator.EQUAL, value: partnerId },
        {
          field: 'CodeType',
          operator: Operator.EQUAL,
          value: CodeType.Agreement,
        },
        {
          field: 'END_DATE',
          operator: Operator.GTE,
          value: toServerFormat(new Date()),
        },
      ],
    })
    const response = await partnerFlagsSource.fetch()
    if (response && response.items) {
      agreements = response.items
    }

    return agreements
  }

  public isActionWIP = (status: EActionStatus) => {
    return status === EActionStatus.WIP
  }

  public isActionWaiting = (status: EActionStatus) => {
    return status === EActionStatus.Waiting
  }

  public isActionNew = (status: EActionStatus) => {
    return status === EActionStatus.New
  }

  public getAction = async (actionId: number, force: boolean = false): Promise<IAction> => {
    const actionsCrud = CrudStore.get<IAction>(CrudStoreItemOnboarding.Actions, 'check-action')
    return actionsCrud.getById({ id: actionId, force })
  }

  public executeTransition = async (
    { requestId, actionId, transitionId }: TRequestTriad,
    cancelIfActionNotExising: boolean = false,
    cancelIfActionNotWipOrWaitingOrNew: boolean = false //temporary fix because EmailValidation action sometimes is stuck
  ) => {
    if (cancelIfActionNotExising || cancelIfActionNotWipOrWaitingOrNew) {
      const action = await this.getAction(actionId, true)
      // TODO: Refactor it
      if (cancelIfActionNotExising && !action) {
        return { success: true, message: '' }
      }
      if (
        cancelIfActionNotWipOrWaitingOrNew &&
        !this.isActionWIP(action?.Status) &&
        !this.isActionWaiting(action?.Status) &&
        !this.isActionNew(action?.Status)
      ) {
        return { success: true, message: '' }
      }
    }

    // этот набор крудов нужен для менеджмента состояния в админке на странице редактирования регистрации
    const notificationSource = CrudStore.get(
      CrudStoreItemOnboarding.RequestNotifications,
      'notificationsList'
    )
    const actionsForGridSource = CrudStore.get(CrudStoreItemOnboarding.ActionsForGrid, 'actionList')
    const processSource = CrudStore.get(
      CrudStoreItemOnboarding.ProcessesProgress,
      'processesProgress'
    )
    const reqDetail = CrudStore.get<IRequest>(CrudStoreItemOnboarding.RequestList, 'req-detail')
    const myActions = CrudStore.get<IExtendAction>(
      CrudStoreItemOnboarding.MyActionsPage,
      'my-actions-page'
    )
    const approvalActionRetail = CrudStore.get(
      CrudStoreItemOnboarding.Actions,
      'approval-action-retail'
    )
    const crudRetailRequests = CrudStore.get(
      CrudStoreItemOnboarding.RetailOnboardingExtRequests,
      'RetailOnboardingRequests'
    )
    const historySource = CrudStore.get(CrudStoreItemOnboarding.RequestHistory)

    const res = await OnboardingApi.executeTransition({
      requestId,
      actionId,
      transitionId,
    })

    if (!res.success) {
      showMessage(res.message)
    } else {
      getUrlParam('EntryId') === `${actionId}` && history.push(deleteParamsFromUrl(['EntryId']))

      reqDetail.removeQueries(true)
      processSource.removeQueries()
      notificationSource.removeQueries()
    }
    actionsForGridSource.removeQueries(true)
    historySource.removeQueries()
    myActions.removeQueries(true)
    approvalActionRetail.removeQueries(true)
    crudRetailRequests.removeQueries(true)
    thirdPartyLogsApi.invalidateTypeCrud(ThirdPartyTypeCrudCacheKeys.PartnerOrRequest, true)

    return res
  }

  public validateCompanyData = async (data: IBPRegistrationCompanyData) => {
    return OnboardingApi.validateCompanyData(data)
  }

  public submitBPStep = async <T>({
    requestId,
    actionId,
    transitionId,
    onboardingRequestData,
    modifiedFields,
  }: TExecuteTransitionPayload<T>) => {
    return await OnboardingApi.submitBPStep<T>({
      requestId,
      actionId,
      transitionId,
      onboardingRequestData,
      modifiedFields,
    })
  }

  /**
   * @deprecated use actionService.reopenOne instead
   * @param actionId
   * @param requestId
   */
  public reopenAction = async (actionId: number, requestId: number) => {
    const notificationSource = CrudStore.get(
      CrudStoreItemOnboarding.RequestNotifications,
      'notificationsList'
    )
    const actionsForGridSource = CrudStore.get(CrudStoreItemOnboarding.ActionsForGrid, 'actionList')
    const processSource = CrudStore.get(
      CrudStoreItemOnboarding.ProcessesProgress,
      'processesProgress'
    )
    const reqDetail = CrudStore.get<IRequest>(CrudStoreItemOnboarding.RequestList, 'req-detail')
    const historySource = CrudStore.get(CrudStoreItemOnboarding.RequestHistory)
    const res = await OnboardingApi.reopenAction(actionId, requestId)
    if (res.success) {
      reqDetail.removeQueries(true)
      processSource.removeQueries()
      notificationSource.removeQueries()
      actionsForGridSource.removeQueries(true)
      historySource.removeQueries()
    }

    return res
  }

  public resendNotification = async (
    campaignId: number,
    notificationData?: Partial<INotificationData>
  ) => {
    let result = false
    const notificationSource = CrudStore.get(
      CrudStoreItemOnboarding.RequestNotifications,
      'notificationsList'
    )
    const res = await OnboardingApi.resendNotification(campaignId, notificationData)
    if (res.success) {
      notificationSource.removeQueries(true)
      result = true
    } else {
      fail(res.message)
    }

    return result
  }

  public sendRejectNotification = async (
    requestId: number,
    templateId: number,
    mailTo: string,
    CC: string,
    mailFrom: string
  ) => {
    const notificationSource = CrudStore.get(
      CrudStoreItemOnboarding.RequestNotifications,
      'notificationsList'
    )

    const res = await OnboardingApi.sendRejectNotification(
      requestId,
      templateId,
      mailTo,
      CC,
      mailFrom
    )
    if (!res.success) {
      showMessage(res.message)
      return
    } else {
      notificationSource.removeQueries(true)
    }
    return res.success
  }

  public rejectRequest = async (reqId: number, comment: string) => {
    const reqSource = CrudStore.get<IRequest>(CrudStoreItemOnboarding.RequestList, 'req-detail')
    const actSource = CrudStore.get(CrudStoreItemOnboarding.ActionsForGrid, 'actionList')
    const res = await OnboardingApi.rejectRequest(reqId, comment)
    if (!res.success) {
      showMessage(res.message)
      return
    } else {
      reqSource.removeQueries(true)
      actSource.removeQueries(true)
    }
  }

  public executeService = async (actionId: number, serviceUrl: string) => {
    const source = CrudStore.get(CrudStoreItemOnboarding.LNRFormData, 'lnrForm')
    const res = await OnboardingApi.executeService(actionId, serviceUrl)
    if (!res.success) {
      showMessage(res.message)
      return
    } else {
      source.removeQueries(true)
    }
  }

  public verifyToken = async (token: string) => {
    const res = await OnboardingApi.verifyToken(token)
    return res.success
  }

  public async callRecalcAudience(requestId: number, comment: string) {
    const actionsForGridSource = CrudStore.get(CrudStoreItemOnboarding.ActionsForGrid, 'actionList')
    const res = await OnboardingApi.callRecalcAudience(requestId, comment)
    if (!res.success) {
      showMessage(res.message)
      return
    } else {
      actionsForGridSource.removeQueries(true)
    }
  }

  public calcFormProgress = async (
    formDetail: IObjectAny,
    formExtInfoSource: Crud<IFormCollector>,
    reqSource: Crud<IRequest>
  ): Promise<number> => {
    if (Object.values(formDetail.parameters).length) {
      const formExtInfo = await formExtInfoSource.getById({ id: formDetail.formId, force: true })
      if (!formExtInfo || !formExtInfo.Crud) {
        return 0
      }
      const crud = formExtInfo && CrudStore.get(formExtInfo.Crud)
      const req = await getRequest(
        Object.keys(formDetail.parameters)[0] === 'RequestId'
          ? (Object.values(formDetail.parameters)[0] as string)
          : undefined,
        reqSource
      )
      let valueForSearch
      if (
        formDetail.Ingerited &&
        Object.keys(formDetail.parameters)[0] === 'RequestId' &&
        req.Parent
      ) {
        valueForSearch = req.Parent
      } else {
        valueForSearch = Object.values(formDetail.parameters)[0]
      }
      const byIdValue =
        crud &&
        (await crud.getById({
          id: valueForSearch,
          keyField: Object.keys(formDetail.parameters)[0],
        }))
      return byIdValue && formExtInfo && formExtInfo.CompletenessField
        ? byIdValue[formExtInfo.CompletenessField] || 0
        : 0
    }
    return 0
  }
  public fetchForms = async (
    filter: IDataProviderFilter,
    paging: IPaging | IPagingFromTo,
    sort: IDataProviderSort | IDataProviderSort[] | undefined
  ): Promise<{ Data: IForm[] }> => {
    const source = CrudStore.get(CrudStoreItemOnboarding.Actions, 'form-actions')

    const reqSource = CrudStore.get<IRequest>(CrudStoreItemOnboarding.RequestList, 'req-detail')
    const formExtInfoSource = CrudStore.get<IFormCollector>(
      CrudStoreItem.FormCollector,
      'data_collector_table'
    )
    const mainFilter = filter.filters.filter((el) => (el as IFilter).field !== 'Progress')
    const isWithProgressCalculation = !!filter.filters.find(
      (el) => (el as IFilter).field === 'Progress'
    )
    mainFilter.push(
      {
        field: 'Status',
        operator: Operator.NOTEQUAL,
        value: EActionStatus.New,
      },
      {
        field: 'Status',
        operator: Operator.NOTEQUAL,
        value: EActionStatus.Waiting,
      },
      {
        field: 'Status',
        operator: Operator.NOTEQUAL,
        value: EActionStatus.NADone,
      }
    )

    source.setFilter({
      ...filter,
      filters: mainFilter,
    })

    sort && source.setSort(sort)
    const response = await source.fetch({ force: true, skipTotal: true })
    const result: TActionForm[] = []

    for (const item of response.items) {
      const responsibleUsers = getResponsibleUsers(item)
      let collectedData = []
      try {
        collectedData = item.CollectedData ? JSON.parse(item.CollectedData) : []
      } catch (e) {
        Logger.error(e)
      }
      const forms = collectedData.filter((el: IObjectAny) => el.type === 'form')
      for (const form of forms) {
        try {
          const formDetail = JSON.parse(form.field)
          let progress = null
          if (isWithProgressCalculation) {
            progress = await this.calcFormProgress(formDetail, formExtInfoSource, reqSource)
          }
          const currentForm = JSON.stringify([form])
          const existing = result.find((el) => el.Form === currentForm)
          if (existing) {
            existing.Description += `, Process: ${item.Process} / Action: ${item.Name}`
          } else {
            result.push({
              action: item,
              ActFormId: `${item.EntryId}_${formDetail.formId}`,
              Form: currentForm,
              FormTitle: formDetail.formTitle,
              Completness: progress,
              SelectedPrimaryUser: responsibleUsers.primary.email,
              Description: `Process = ${item.Process} / Action = ${item.Name}`,
              Disabled: item.Status !== EActionStatus.WIP,
            })
          }
        } catch (e) {
          Logger.error(e)
        }
      }
    }

    const newPaging = paging as IPagingFromTo
    return {
      Data: result.slice(
        newPaging.from,
        newPaging.from === newPaging.to ? newPaging.from + 1 : newPaging.to
      ),
    }
  }

  public findChild = (actionList: IAction[], parent: IAction) => {
    let deepIndex = parent.Deep
    let child = 0
    actionList.forEach((item) => {
      if (item.ParentUUID === parent.UUID) {
        item.Deep = deepIndex + 1
        if (unvisibleStatuses.includes(item.Status)) {
          this.findChild(actionList, item)
        } else {
          child += 1
          deepIndex += this.findChild(actionList, item)
        }
      }
    })
    return child
  }

  public sortFunction = (actions: IAction[]) => {
    const withoutParents: IAction[] = []
    const actionList = [...actions]
    actions.forEach((item) => {
      if (!item.ParentUUID) {
        item.Deep = 0
        withoutParents.push(item)
      }
    })
    withoutParents.forEach((item) => {
      this.findChild(actionList, item)
    })
    return actionList.sort(function (a, b) {
      return a.Deep - b.Deep
    })
  }

  public fetchActionsForGrid = async (
    filter: IDataProviderFilter
  ): Promise<{ Data: IAction[] }> => {
    const requestSource = CrudStore.get<IRequest>(CrudStoreItemOnboarding.RequestList, 'req-detail')
    const actionSource = CrudStore.get(CrudStoreItemOnboarding.Actions, 'actionList-grid')

    const requestFilter = requestSource.getFilter()
    if (!requestFilter) {
      throw new Error('requestSource should contains id')
    }

    const requestId = this.getEntryIdFromFilter(requestFilter)
    const request = await requestSource.getById({ id: requestId, keyField: 'EntryId' })
    const requestParent = request?.Parent

    const mainActionFilter = filter.filters.filter((el) => (el as IFilter).field === 'RequestId')
    const additionalActionFilters = filter.filters.filter(
      (el) => (el as IFilter).field !== 'RequestId'
    )
    let newFilter: IDataProviderFilter
    if (requestParent) {
      const inheritFilter = {
        logic: Logic.AND,
        filters: [
          {
            field: 'RequestId',
            operator: Operator.EQUAL,
            value: requestParent,
          },
          { field: 'Inheritable', operator: Operator.EQUAL, value: 1 },
        ],
      }

      newFilter = {
        logic: Logic.AND,
        filters: [
          {
            logic: Logic.OR,
            filters: [inheritFilter],
          },
        ],
      }

      if (
        mainActionFilter.length &&
        isInstanceOf<IDataProviderFilter>(newFilter.filters[0], 'filters')
      ) {
        newFilter.filters[0].filters.push(...mainActionFilter)
      }
      if (additionalActionFilters) {
        newFilter.filters.push(...additionalActionFilters)
      }
    } else {
      newFilter = filter
    }
    actionSource.removeQueries()
    actionSource.setFilter(newFilter)
    const resultArr: IAction[] = []
    const result = await actionSource.fetch()
    const items: IAction[] = result.items
    items.forEach((el) => {
      if (el.RequestId === requestParent) {
        resultArr.push({
          ...el,
          EntryId: -el.EntryId,
          Name: `${el.Name}(From Parent Request)`,
          Process: `${el.Process}(From Parent Request)`,
          LinkToAnotherRequest: {
            rid: requestParent,
            EntryId: el.EntryId,
          },
        })
      } else {
        resultArr.push(el)
      }
    })
    return {
      Data: resultArr.sort(
        (a, b) =>
          +a.Name.includes('(From Parent Request)') - +b.Name.includes('(From Parent Request)')
      ),
    }
  }

  public updateNotifTemplatesLocaleRule = async (templateName: string, localeRule: string) => {
    const url = proxy('/webservice/197/sp/v3/spUpdateOnbNotificationTemplates/call')

    const headers = await this.prepareMBEHeader()

    const payload = {
      [`p.templateName`]: templateName,
      [`p.localeRule`]: localeRule,
    }

    const response = await Rest.post({ url, payload, headers })
    return {
      data: response['Rows'] && response['Rows'][0] ? response['Rows'][0] : {},
    }
  }

  public fetchMainParameter = async (
    type: string,
    partnerId: string,
    page: number,
    size: number,
    contactId?: string,
    sort?: IDataProviderSort[]
  ) => {
    const response = await OnboardingApi.fetchMainParameter(
      type,
      partnerId,
      page,
      size,
      contactId,
      sort
    )
    const result: { Data: IMainParam[] } = { Data: [] }

    if (
      response &&
      response.status === 'success' &&
      response.data &&
      response.data.specializations
    ) {
      result.Data = response.data.specializations
    } else {
      fail(response.message)
    }

    return result
  }

  public fetchBPRegData = async (filter: IDataProviderFilter) => {
    if (filter.filters && filter.filters[0]) {
      const value = (filter.filters[0] as IFilter).value as string
      if (value) {
        const res = await OnboardingApi.fetchBPRegData(value as string)
        const newData: IObjectAny[] = []

        res.data.forEach((item: IObjectAny) => {
          const newItem = { ...item }
          newItem.EnrollmentId = item.contactData.enrollmentId
          newItem.Status = item.contactData.status
          newItem.ContactID = item.contactData.contactId || 'new'
          newItem.FirstName = item.contactData.firstName
          newItem.LastName = item.contactData.lastName
          newItem.Email = item.contactData.email
          newData.push(newItem)
        })

        return {
          Data: newData,
        }
      }
    }
    return {
      Data: [],
    }
  }

  public fetchDetailedBPReconfirmationList = async (filter: IDataProviderFilter) => {
    const result: { Data: IReconfirmationDetails[] } = { Data: [] }

    if (filter.filters && filter.filters.length) {
      let partnerId: string | undefined
      let startDate: string | undefined
      let endDate: string | undefined

      for (const condition of filter.filters) {
        if (
          isInstanceOf<IFilter>(condition, (obj) => 'field' in obj && 'value' in obj) &&
          typeof condition.value === 'string'
        ) {
          if (condition.field === 'PartnerId') {
            partnerId = condition.value
          } else if (condition.field === 'StartDate') {
            startDate = condition.value
          } else if (condition.field === 'EndDate') {
            endDate = condition.value
          }
        }
      }

      if (partnerId) {
        const now = toServerFormat(new Date())
        startDate = startDate ?? now
        endDate = endDate ?? now

        const response = await OnboardingApi.fetchDetailedBPReconfirmationList(partnerId, {
          startDate,
          endDate,
        })

        if (response && response.status === 'success' && response.data && response.data.result) {
          result.Data = response.data.result.map((item) => ({
            ...item,
            EnrollmentId: item.contactData.enrollmentId,
            Status: item.contactData.status,
            ContactID: item.contactData.contactId || 'new',
            FirstName: item.contactData.firstName,
            LastName: item.contactData.lastName,
            Email: item.contactData.email,
          }))
        } else {
          showMessage(response.message)
        }
      }
    }

    return result
  }

  public fetchBackupUsers = async (
    filter: IDataProviderFilter,
    paging: IPaging | IPagingFromTo,
    sort: IDataProviderSort | IDataProviderSort[] | undefined
  ) => {
    const sortServiceVariant = getServiceSortVariant(sort)
    const response = await OnboardingApi.fetchBackupUsers(
      filter,
      paging as IPaging,
      sortServiceVariant
    )
    const result: { Data: IBackupUser[] } = { Data: [] }

    if (response && response.status === 'success' && response.data && response.data.items) {
      result.Data = response.data.items
    } else {
      showMessage(response.message || 'Failed to fetchBackupUsers')
    }

    return result
  }

  public amsSearch = async (
    filter: IDataProviderFilter,
    paging: IPaging | IPagingFromTo,
    sort: IDataProviderSort | IDataProviderSort[] | undefined
  ) => {
    const sortServiceVariant = getServiceSortVariant(sort)
    const res = await OnboardingApi.amsSearch(filter, paging as IPaging, sortServiceVariant)

    return {
      Data: res.data.items,
    }
  }

  public simplePartnerSearch = async (
    filter: IDataProviderFilter,
    paging: IPaging | IPagingFromTo,
    sort: IDataProviderSort | IDataProviderSort[] | undefined
  ) => {
    const sortServiceVariant = getServiceSortVariant(sort)
    const res = await OnboardingApi.simplePartnerSearch(
      filter,
      paging as IPaging,
      sortServiceVariant
    )

    return { Data: res.data.items }
  }

  public saveBackupUser = async (backupUser: Partial<IBackupUser>) => {
    const { EntryId, CreatedBy, Created, Modified, ModifiedBy, From, To, ...other } = backupUser
    const date = (value?: string) => (value ? new Date(value) : new Date())
    const backupUserForSave: Partial<IBackupUser> = {
      ...other,
      From: toServerDateTimeOffset(setStartDate(date(From))),
      To: toServerDateTimeOffset(setEndDate(date(To))),
      id: EntryId,
    }

    const res = await OnboardingApi.saveBackupUser(backupUserForSave)
    if (!res.success) {
      showMessage(res.message)
    }
  }

  public deleteBackupUser = async (id: number) => {
    const res = await OnboardingApi.deleteBackupUser(id)
    if (!res.success) {
      showMessage(res.message)
    }
  }

  public fetchPartnersForBPRegistrationStatusCheckNew = async (
    filter: IDataProviderFilter,
    paging: IPaging | IPagingFromTo
  ) => {
    if (filter.filters.length > 0) {
      const fields = {}
      const filters = filter.filters as IFilter[]
      filters.forEach((filter) => {
        fields[filter.field] = filter.value
      })

      const pagination: IPaging = {
        page: paging['to'] / (paging['to'] - paging['from']) - 1,
        pageSize: paging['to'] - paging['from'],
      }
      const res = await OnboardingApi.fetchPartnersForBPRegistrationStatusCheckNew(
        fields,
        pagination
      )

      return {
        Data: res.data,
      }
    }
    return {
      Data: [],
    }
  }

  public checkRegExists = async (
    email: string,
    requestType: RequestTypes,
    excludingRid?: number,
    checkAmongRejected?: boolean
  ): Promise<{
    RequestId: number
    MainParam: string
    Status: RequestStatus
    Submitted: number
    IsBP?: boolean
  } | null> => {
    if (requestType === RequestTypes.BPRegistration) {
      return OnboardingApi.checkBPRegistrationRequestExists(email, excludingRid)
    }
    if (requestType !== RequestTypes.BPReconfirmation) {
      return null
    }
    const key = CrudStoreItemOnboarding.BPReconfirmationDetail
    const source = CrudStore.get(key, 'check-existing')
    source.setPaging({ page: 0, pageSize: 1 })
    source.setSort({ field: 'RequestId', dir: 'desc' })
    const filters: IFilter[] = [
      {
        field: 'RegistrationEmail',
        operator: Operator.EQUAL,
        value: email,
      },
    ]
    if (!checkAmongRejected) {
      filters.push({
        field: 'Status',
        operator: Operator.NOTEQUAL,
        value: RequestStatus.Rejected,
      })
    }
    if (excludingRid) {
      filters.push({
        field: 'RequestId',
        operator: Operator.NOTEQUAL,
        value: excludingRid,
      })
    }
    source.setFilter({
      logic: Logic.AND,
      filters,
    })
    const result = await source.fetch({ force: true, skipTotal: true })
    if (result.items.length) {
      return result.items[0]
    }
    return null
  }

  public getPFPForm = async (requestId: number) => {
    const source = CrudStore.get(CrudStoreItemOnboarding.PFPOnboardingRequests, `get-pfp-form`)

    source.setPaging({ page: 0, pageSize: 1 })
    source.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'RequestId',
          operator: Operator.EQUAL,
          value: requestId,
        },
      ],
    })
    const result = await source.fetch({ skipHierarchyFilter: true, force: true, skipTotal: true })
    source.removeQueries()
    if (result.items.length) {
      return result.items[0]
    }
    return null
  }

  /**
   * @deprecated PFP_LEGACY_RID — dies with the legacy terms-and-conditions page.
   *
   * Four fields only — `RequestId`, `MainParameter`, `Data`, `Status` — and `Data` exactly as the
   * view holds it. The page derives the right to sign the terms from `parseJson(Data).Email`, so
   * nothing here may substitute a document for a null one.
   *
   * Typed `IRequestDataExt` because the caller's state is, and because that was already the shape of
   * this lie: the dataset returned the view's ~20 columns under the same 65-property interface. The
   * two the page reads and never had — `MainParam` and `RejectionComment` — stay `undefined`, as
   * before, because `PartnerRegistrationsExtView` has no such columns.
   */
  public getPartnerRegistration = async (
    requestId: number
  ): Promise<TLegacyRidRead<IRequestDataExt>> => {
    return legacyRidApi.fetchPartnerRegistration<IRequestDataExt>(requestId)
  }

  public updatePfpFormData = async <T>(
    data: IObjectAny,
    requestId: number,
    requestType: RequestTypes | undefined = undefined
  ): Promise<T | null> => {
    const pfp = await this.getPFPForm(requestId) //get actual data before save
    const crud = CrudStore.get<T>(
      CrudStoreItemOnboarding.PFPOnboardingRequests,
      'updatePfpFormData'
    )
    let res
    if (pfp) {
      const parsedData = parseObject(pfp.Data || '')
      res = await crud.update(
        {
          formId: '708',
          code: 'PFPOnboardingRequests',
        },
        [{ ...pfp, Data: pfp.Data ? { ...parsedData, ...data } : data }]
      )
    } else {
      res = await crud.create(
        {
          formId: '708',
          code: 'PFPOnboardingRequests',
        },
        [{ Data: data, RequestId: requestId, RequestType: requestType }]
      )
    }

    //will be removed when logic will be moved to service
    return res.length && res[0]?.Data ? parseJson<T>(res[0].Data || '{}') : null
  }

  public updateForm661 = async (
    requestType: RequestTypes,
    requestId: number,
    country?: string,
    companyName?: string,
    pid?: string
  ) => {
    const reqSource = CrudStore.get(CrudStoreItemOnboarding.RequestList, requestType)

    const { TAT, ...withoutTAT } = await reqSource.getById(requestId)
    const payload = [
      {
        ...withoutTAT,
        ...(country && { Country: country }),
        ...(companyName && { PartnerName: companyName }),
        ...(pid && { PartnerId: pid }),
      },
    ]
    await reqSource.update({ formId: '661', code: 'RequestListForm' }, payload)
  }

  /**
   * @deprecated PFP_LEGACY_RID — dies with the legacy registration wizards.
   *
   * `key` was the CrudStore cache key and is now unused. Kept so the call sites do not have to move
   * in the same change; drop it and them together.
   *
   * Returns the read's outcome, not just the rows: an empty step map is a request that has no
   * steps, and a caller that cannot tell that from a refusal or an outage builds a stepless form
   * out of a failure.
   */
  public getFormConfig = async (
    requestId: number,
    key: string
  ): Promise<TLegacyRidRead<IWorkFlowStepState[]>> => {
    void key

    return legacyRidApi.fetchStepMapping<IWorkFlowStepState>(requestId)
  }

  public getAttachment = async (
    requestId: number,
    actionUUID: string,
    transitionName?: string
  ): Promise<INotificationAttachment | null> => {
    const res = await OnboardingApi.getAttachment(requestId, actionUUID, transitionName)
    if (res && res.length) {
      return res[0]
    }
    return null
  }

  public addLogs = async (logMessage: string, requestId: number, eventType: string) => {
    const source = CrudStore.get(CrudStoreItemOnboarding.RequestHistory, 'logs')
    const data = {
      RequestId: requestId,
      Data: logMessage,
      EventType: eventType,
    }
    await source.create({ formId: '690', code: 'History' }, [data])
  }

  public createContactProfilingRequest = async (
    contactId: string,
    updatedFields: Record<string, any>
  ) => {
    return OnboardingApi.createContactProfilingRequest(contactId, updatedFields)
  }

  public createPartnerProfilingRequest = async (
    partnerId: string,
    updatedFields: Record<string, any>
  ) => {
    return OnboardingApi.createPartnerProfilingRequest(partnerId, updatedFields)
  }

  public getPartnerOrPartnerChangeRequest = async (
    partnerId: string,
    useCache: boolean = false
  ) => {
    const isNewPartner = PartnerHelper.isDummyPartnerRequest(partnerId)
    const crud = isNewPartner
      ? CrudStore.get(CrudStoreItem.NewPartners)
      : CrudStore.get(CrudStoreItem.PartnerAllData)
    return crud.getById({ id: partnerId, force: !useCache, keyField: 'PartnerID' })
  }

  private async prepareMBEHeader() {
    const { app } = appGetState()
    const [accessToken] = await getTokens(app.ownerId)

    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }
    return headers
  }

  public async getUploadHistory(
    filter: IDataProviderFilter,
    paging: IPaging | IPagingFromTo,
    sort?: IDataProviderSort | IDataProviderSort[]
  ) {
    const filterItem = filter.filters.find(
      (item) => isInstanceOf<IFilter>(item, 'field') && item.field === 'Type'
    )
    if (filterItem && isInstanceOf<IFilter>(filterItem, 'field')) {
      const pagination = convertToServerPaginationIfNot(paging)

      return onboardingUploadHistoryApi.getUploadHistory(filter, pagination, sort)
    }

    return null
  }

  public getEntryIdFromFilter(filters: IDataProviderFilter) {
    const entryIdFilter = filters?.filters.find(
      (item: IFilter | IDataProviderFilter) => (item as IFilter).field === 'EntryId'
    ) as IFilter | undefined

    let result
    if (entryIdFilter) {
      result = entryIdFilter.value
    }

    return result
  }
}

export default new OnboardingStoreService()
